import { defineType } from "sanity";
import { designSystemIconPreview } from "../../components/DesignSystemIconInput";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "iconHighlight",
  type: "object",
  title: "Icon Highlights",
  fields: [
    {
      name: "icon",
      title: "Icon",
      type: "designSystemIcon"
    },
    {
      name: "label",
      title: "Label",
      type: "multilingualArrayString"
    }
  ],
  preview: {
    select: {
      title: "label",
      icon: "icon"
    },
    prepare({ title, icon }) {
      return {
        title: multilingualStringPreview(title),
        media: designSystemIconPreview(icon)
      };
    }
  }
});
